const KEYS = {
  ENTER_KEY: 13,
};

export default KEYS;
